<div #mainBox [class.top-box]="isTopBox" [class.bottom-box]="isBottomBox" class="anecdotal-box"
(clickOutside)="onClickOutside()" (mousedown)="startLongPress()" (mouseup)="endLongPress($event)" (mouseleave)="endLongPress($event)" (touchstart)="startLongPress()" (touchend)="endLongPress($event)" (touchcancel)="endLongPress($event)"
[additionalElementRefs]="extraBoxes">
    <div class="flag flex-column  no-select" [class.flag-all-trials]="remainingTrials<=0" >
        {{target?.TargetName}}
        <span class="sd-text">{{target?.DiscriminativeStimulus}}</span>
        <button class="button-anecdotal" (click)="addOrOpenAnecdotal()">{{anecdotals.length>0?'View':'Add'}} Anecdotal Data</button>
        
        <span  class="badge-count" (click)="showExtra()" [class.badge-count-green]="anecdotals.length>=expectedAmount" [class.badge-count-red]="anecdotals.length<expectedAmount">{{anecdotals.length}}/{{expectedAmount}}</span>
        <button class="badge-bottom-left" (click)="openDetails($event)" >?</button>
        <button class="badge-bottom-right" (click)="openDetails($event)" title="Remaining desired Trials" *ngIf="remainingTrials>0"> {{remainingTrials}}</button>  
    </div>
</div>

@if (detailsOpened) {
<app-target-details [target]="target" (onCloseDetails)="onCloseDetails()" [isPreview]="isPreview"></app-target-details>
}

<div class="extra-container" #extraBox [class.hide]="!extraOpened">
    <div class="extra-close" (click)="closeExtra()">X</div>
    <div class="extra-container-textbox">
    <textarea 
      class="anecdotal-textarea"
      rows="8"
      placeholder="Enter anecdotal data here..."
      [(ngModel)]="currentAnecdotal().text"  (blur)="saveAnecdotal()"
    ></textarea>
    <button class="button-anecdotal orange" (click)="addAnecdotal()">Add new Anecdotal</button>
    </div>

    <div class="anecdotal-list">
        <div *ngFor="let anecdotal of anecdotals; let i = index" class="anecdotal-item ">
            <span class="float-right extra-list-trash-icon pointer" (click)="deleteAnecdotal(anecdotal)"><i class="pi pi-trash"></i></span>
            <div class="anecdotal-date">{{ anecdotal.date }} </div>
            <div class="anecdotal-text pointer" title="{{ anecdotal.text }}"  (click)="selectAnecdotal(i)">{{ anecdotal.text }}</div>
        </div>
    </div>
</div>